module.exports = __webpack_public_path__ + "assets/img/browse_2.30aee086.png";